import { FC } from 'react';
import { useGetResourcesQuery } from '../graphql/generated/operations/resource';
import { ResourceCard } from '../components/ResourceCard';
import { Grid, Typography } from '@mui/material';
import { LoadingBackdrop } from '../components/loading.backdrop.tsx';
import { Resource } from '../graphql/generated/graphql.ts';

// Helper function to group resources by type
const groupByType = (resources: Partial<Resource>[]) => {
  return resources.reduce((acc: Record<string, typeof resources>, resource: any) => {
    const type = resource.type || 'Other';
    if (!acc[type]) {
      acc[type] = [];
    }
    acc[type].push(resource);
    return acc;
  }, {});
};

export const ResourcePage: FC = () => {
  const { loading, data } = useGetResourcesQuery();

  if (loading) return <LoadingBackdrop open={true} />;

  const grouped = data?.resources ? groupByType(data.resources) : {};

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Resources
      </Typography>

      {Object.entries(grouped).map(([type, resources]) => (
        <div key={type}>
          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            {type}
          </Typography>
          <Grid container spacing={2}>
            {resources.map((resource) => (
              <Grid item xs={12} md={6} key={resource._id}>
                <ResourceCard resource={resource as Resource} />
              </Grid>
            ))}
          </Grid>
        </div>
      ))}
      {Object.keys(grouped).length === 0 && (
        <Typography variant="body1" sx={{ mt: 2 }}>
          No resources available at the moment.
        </Typography>
      )}
    </>
  );
};
